export default (api) => ({
    list: (params) => api.get('/organizations', { params }),
    create: (params) => api.post('/organizations', params),
    get: ({ organizationUid }) => api.get(`/organizations/${organizationUid}`),
    delete: ({ organizationUid }) => api.delete(`/organizations/${organizationUid}`),
    update: ({ organizationUid, params }) => api.put(`/organizations/${organizationUid}`, params),
})
